export default {
  "labels": {
    "averageShiftTime": "Jornada promedio",
    "quantityLongRest": "Descansos de 48 horas",
    "drivenTimeMidnight": "Horas conducidas entre 0:00 y 6:00",
    "drivenTimeSunRise": "Horas conducidas entre 3:00 y 5:00",
    "shiftOverThreshPercentage": "Jornadas sobre 12 horas",
    "startShiftDifferenceTime": "Diferencia inicio jornadas",
    "lowerRestTime": "Descansos de 8 horas incumplidos tras iniciar una jornada",
    "lowerRestTimeQuantity": "Cantidad de veces que, tras un inicio de jornada, no se cumple con el descanso mínimo legal de 8 horas continuas en las 24 horas anteriores al inicio de jornada.",
    "lowerRestTimeAverage": "Promedio de la cantidad de veces que, tras un inicio de jornada, no se cumple con el descanso mínimo legal de 8 horas continuas en las 24 horas anteriores al inicio de jornada.",
    "detailMainIndicators": "Detalle principales indicadores",
    "startShift": "Horarios de inicio de jornada",
    "rotation": "Rotación",
    "shiftLength": "Duración de jornadas",
    "consecutiveWorkingDays": "Días consecutivos trabajados",
    "evFatigue": "EV. FATIGA",
    "noteDaily": "NOTA DIARIA",
    "averageShiftTimeText": "Promedio de la duración en horas de las jornadas diarias de los conductores.",
    "quantityLongRestTextDriverView": "Número de descansos de 48 horas en el intervalo seleccionado.",
    "quantityLongRestText": "Promedio del número de descansos de 48 horas de cada conductor en el intervalo seleccionado.",
    "drivenTimeMidnightText": "Horas promedio conducidas en este intervalo, representando la conducción nocturna.",
    "drivenTimeSunRiseText": "Horas promedio conducidas en este intervalo, representando la conducción nocturna crítica. En este horario hay hasta 20 veces más probabilidad de tener un accidente, por lo que es importante monitorearlo.",
    "shiftOverThreshPercentageText": "Porcentaje de las jornadas diarias mayores a 12 horas, desde el inicio del turno hasta el término de éste.",
    "startShiftDifferenceTimeText": "Diferencia en horas entre las horas de inicio de un día con el día siguiente. Por ejemplo, si un conductor comienza su trabajo a las 7:30 un día y a las 9:30 el día siguiente, esta diferencia es de 2 horas.",
    "lowerRestTimePercentageText": "Porcentaje de los descansos que no cumplen con el mínimo legal de 8 horas de descanso continuo.",
    "startDay": "Inicio de jornada a las",
    "times": "veces",
    "timeDay": "Hora del día",
    "betweenStartShifts": "entre inicio de jornadas",
    "hoursBetweenStartShifts": "Horas entre inicio de jornadas",
    "durationDay": "Duración de jornada",
    "durationHours": "Duración (horas)",
    "days": "Días",
    "consecutive": "consecutivos",
    "consecutiveDays": "Días consecutivos"
  }
};


// WEBPACK FOOTER //
// ./source/client/components/locales/language_configuration/spanish/fatigue/fatigueIndicators.js